var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "8" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "SalesMaximumQuantity" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.Code"),
                        error: _vm.$v.form.Code
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t(
                          "insert.SalesMaximumQuantity.Description1"
                        ),
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.StatusId"),
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox2", {
                        attrs: {
                          type: "number",
                          disabled: _vm.insertReadonly.StatusId,
                          toggle: ""
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.BeginDate"),
                        error: _vm.$v.form.BeginDate
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.BeginDate },
                        model: {
                          value: _vm.form.BeginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "BeginDate", $$v)
                          },
                          expression: "form.BeginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.SalesMaximumQuantity.EndDate"),
                        error: _vm.$v.form.EndDate
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.EndDate },
                        model: {
                          value: _vm.form.EndDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "EndDate", $$v)
                          },
                          expression: "form.EndDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.SalesMaximumQuantity.CustomerList")
                  }
                },
                [
                  _c("NextDetailPanelSalesMaxQuantity", {
                    attrs: { items: _vm.salesMaximumQuantityCustomersItems },
                    model: {
                      value: _vm.form.SalesMaximumQuantityCustomers,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "SalesMaximumQuantityCustomers", $$v)
                      },
                      expression: "form.SalesMaximumQuantityCustomers"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe7dc996", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe7dc996","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SalesMaximumQuantity/insert.vue
// module id = null
// module chunks = 